import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { FiX } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import {
  getViewProfile,
  updateProfile,
} from "../../../redux/slices/profileSlice";

const ResumeUrlModal = ({ show,
  onHide,
  value = "",
  onSave,
  isApplyPage = false, }) => {
  const dispatch = useDispatch();
  const store = useSelector((state) => state.profile);

  const [resumeUrl, setResumeUrl] = useState("");
  const [error, setError] = useState("");

  // Load existing value
  // useEffect(() => {
  //   if (!show) return;

  //   const current = store?.profileItem?.data?.nurseProfile?.resume_url;

  //   if (current) {
  //     setResumeUrl(current);
  //   }
  // }, [show, store?.profileItem]);
  useEffect(() => {
  if (!show) return;

  if (isApplyPage) {
    // ✅ Apply page
    setResumeUrl(value || "");
  } else {
    // ✅ Profile page
    const current = store?.profileItem?.data?.nurseProfile?.resume_url;

    if (current) {
      setResumeUrl(current);
    }
  }

// ❗ ONLY depend on show
}, [show]);

  
  // const handleSave = () => {
  //   const trimmedUrl = resumeUrl.trim();

  //   if (!trimmedUrl) {
  //     setError("Resume URL is required");
  //     return;
  //   }

  //   if (trimmedUrl.length > 500) {
  //     setError("URL must be less than 500 characters");
  //     return;
  //   }

  //   // URL validation
  //   const urlPattern = /^(https?:\/\/)?(www\.)?([a-z0-9-]+\.)+[a-z]{2,}/i;

  //   if (!urlPattern.test(trimmedUrl)) {
  //     setError("Please enter a valid URL");
  //     return;
  //   }

  //   const formData = new FormData();

  //   formData.append(
  //     "name",
  //     store?.profileItem?.data?.name ||
  //       store?.profileItem?.data?.full_name ||
  //       "",
  //   );

  //   formData.append("resume_url", trimmedUrl);

  //   dispatch(updateProfile(formData));
  // };
const handleSave = () => {
  const trimmedUrl = resumeUrl.trim();

  if (!trimmedUrl) {
    setError("Resume URL is required");
    return;
  }

  if (trimmedUrl.length > 500) {
    setError("URL must be less than 500 characters");
    return;
  }

  const urlPattern = /^(https?:\/\/)?(www\.)?([a-z0-9-]+\.)+[a-z]{2,}/i;

  if (!urlPattern.test(trimmedUrl)) {
    setError("Please enter a valid URL");
    return;
  }

  if (isApplyPage) {
    // ✅ LOCAL
    onSave(trimmedUrl);
    onHide();
  } else {
    // ✅ API
    const formData = new FormData();

    formData.append(
      "name",
      store?.profileItem?.data?.name ||
        store?.profileItem?.data?.full_name ||
        ""
    );

    formData.append("resume_url", trimmedUrl);

    dispatch(updateProfile(formData));
  }
};
  useEffect(() => {
    if (store?.actionFlag === "PROFILE_UPDT_SCS") {
      onHide();
    }
  }, [store?.actionFlag]);
  useEffect(() => {
    if (show) {
      // dispatch(getViewProfile());
    }
  }, [show, dispatch]);
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      size="md"
      dialogClassName="custom-modal profile-other-details-modal"
    >
      <Modal.Header>
        <h5 className="modal-title">Enter your resume URL</h5>

        <Button className="close-btn" onClick={onHide}>
          <FiX size={24} />
        </Button>
      </Modal.Header>

      <Modal.Body>
        <div className="form-group">
          <label className="col-label">Resume URL</label>

          <Form.Control
            type="url"
            placeholder="https://example.com/resume.pdf"
            value={resumeUrl}
            maxLength={500}
            onChange={(e) => {
              setResumeUrl(e.target.value);
              setError("");
            }}
            className={`col-input ${error ? "is-invalid" : ""}`}
          />
        </div>

        {error && <div className="error-message mt-2">{error}</div>}

        <div className="text-center mt-4">
          <Button
            className="btn-primary px-4"
            onClick={handleSave}
            disabled={store?.isLoading || !resumeUrl.trim()}
          >
            {store?.isLoading ? "Saving..." : "Save"}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ResumeUrlModal;
